// extracted by mini-css-extract-plugin
export default {"pWidth":"Authentication_pWidth__MkiC8","registrationLink":"Authentication_registrationLink__vdkbJ"};